/**
 * Línea de servicios de IA de E-ASY.
 * Sin micro-marca separada: SapiencIA diluye autoridad y no es comercial.
 * Vulpin se nombra en producto (IA privada / Social), no como paraguas de toda la línea.
 */
export const IA_BRAND_NAME = 'E-ASY';

export const IA_HUB = {
  path: '/soluciones-ia',
  label: 'Soluciones de IA',
  url: 'https://e-asy.es/soluciones-ia',
};

export const IA_SERVICES = {
  cumplimiento: {
    id: 'cumplimiento',
    path: '/cumplimiento-ia',
    url: 'https://e-asy.es/cumplimiento-ia',
    label: 'Cumplimiento y alfabetización IA',
    shortLabel: 'Cumplimiento IA (Art. 4)',
    blogSlug: 'articulo-4-ai-act-pyme-canaria',
  },
  agentes: {
    id: 'agentes',
    path: '/agentes-ia',
    url: 'https://e-asy.es/agentes-ia',
    label: 'Agentes IA y automatización',
    shortLabel: 'Agentes IA',
    blogSlug: 'donde-desplegar-agente-ia-azure-on-premise',
  },
  privada: {
    id: 'privada',
    path: '/ia-privada',
    url: 'https://e-asy.es/ia-privada',
    label: 'IA privada / soberana',
    shortLabel: 'IA privada',
    blogSlug: 'donde-desplegar-agente-ia-azure-on-premise',
  },
  produccion: {
    id: 'produccion',
    path: '/servicios/ia-en-produccion',
    url: 'https://e-asy.es/servicios/ia-en-produccion',
    label: 'IA en producción',
    shortLabel: 'Desplegar IA',
    blogSlug: 'de-prototipo-chatgpt-cursor-a-produccion',
  },
};

export const IA_CASOS = {
  path: '/casos',
  url: 'https://e-asy.es/casos',
  label: 'Casos de referencia',
};

export const buildIaBreadcrumb = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Inicio',
      item: 'https://e-asy.es/',
    },
    ...items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 2,
      name: item.name,
      item: item.url,
    })),
  ],
});

export const buildIaServiceSchema = ({ name, description, url, serviceType }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name,
  description,
  url,
  serviceType,
  provider: {
    '@type': 'Organization',
    name: IA_BRAND_NAME,
    url: 'https://e-asy.es',
  },
  areaServed: [
    { '@type': 'AdministrativeArea', name: 'Canarias' },
    { '@type': 'Country', name: 'España' },
  ],
});
